import { isValue } from 'shared/src/util/typeGuard'
import { Distance } from 'shared/src/util/unit/distance'
import { Volume } from 'shared/src/util/unit/volume'
import type { DtoInsideDeviceMetering, ProcessedInsideDeviceMetering } from 'whats_inside/src/model'

export class InsideDeviceMeteringProcessor {
  static process(metering: DtoInsideDeviceMetering): ProcessedInsideDeviceMetering {
    return {
      ...metering,
      normalizedDistance: isValue(metering.normalizedDistanceMm)
        ? Distance.millimeter(metering.normalizedDistanceMm)
        : undefined,
      fillHeight: Distance.millimeter(metering.fillHeightMm),
      quantity: {
        unit: metering.quantity.unit,
        value: Volume.liter(metering.quantity.value),
      },
    }
  }

  static processList(meterings: DtoInsideDeviceMetering[]): ProcessedInsideDeviceMetering[] {
    return meterings.map((metering) => this.process(metering))
  }
}
